import React from "react";

function Loading() {
  return (
    <div className="loader-container w-[100%] h-[100vh] flex items-center justify-center">
      <div className="loader text-white">Loading...</div>
    </div>
  );
}

export default Loading;
